import { Timestamp } from 'firebase/firestore';

export enum NotificationType {
  CONNECTION_REQUEST = 'connection_request',
  CONNECTION_ACCEPTED = 'connection_accepted',
  CONNECTION_REJECTED = 'connection_rejected',
  NEW_MESSAGE = 'new_message',
  POST_LIKE = 'post_like',
  POST_COMMENT = 'post_comment',
  POST_SHARE = 'post_share',
  NEW_POST = 'new_post',
  SYSTEM = 'system',
  SUPPORT_MESSAGE = 'support_message',
  GROUP_ADDED = 'group_added',

  // Space notifications
  SPACE_UPVOTE = 'space_upvote',
  SPACE_COMMENT = 'space_comment',
  SPACE_FOLLOW = 'space_follow',
  SPACE_MENTION = 'space_mention',
  COMMENT_UPVOTE = 'comment_upvote',
  EVENT_COMMENT = 'event_comment',
  EVENT_MENTION = 'event_mention',
  EVENT_INVITE = 'event_invite',

  // Resource notifications
  NEW_RESOURCE = 'new_resource',
  RESOURCE_APPROVAL_REQUEST = 'resource_approval_request',
  RESOURCE_APPROVED = 'resource_approved',
  RESOURCE_REJECTED = 'resource_rejected',

  // Space notifications
  NEW_SPACE = 'new_space',

  // Member invitation approval
  MEMBER_INVITATION_APPROVAL_REQUEST = 'member_invitation_approval_request',
  MEMBER_INVITATION_APPROVED = 'member_invitation_approved',
  MEMBER_INVITATION_REJECTED = 'member_invitation_rejected',

  // Event notifications
  NEW_EVENT = 'new_event',
  EVENT_ATTENDANCE = 'event_attendance',
}

export enum NotificationPriority {
  LOW = 'low',
  MEDIUM = 'medium',
  HIGH = 'high',
}

export interface NotificationData {
  connectionId?: string;
  spaceId?: string;
  senderId?: string;
  receiverId?: string;
  actorId?: string;
  actorName?: string;
  postId?: string;
  commentId?: string;
  sharerId?: string;
  conversationId?: string;
  eventId?: string;
  eventTitle?: string;
  resourceId?: string;
  title?: string;
  managementUrl?: string;
  myResourcesUrl?: string;
}

export interface FirebaseTimestamp {
  seconds: number;
  _seconds: number;
  nanoseconds: number;
  _nanoseconds: number;
}

export interface Notification {
  id: string;
  userId: string;
  type: NotificationType;
  title: string;
  message: string;
  priority: NotificationPriority;
  data: NotificationData;
  read: boolean;
  createdAt: Timestamp;
}

export interface NotificationsResponse {
  notifications: Notification[];
  unreadCount: number;
  hasMore: boolean;
}
